import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { Device, from, until } from '@helpers/media';
import { headingStyles, paragraphStyles } from '@helpers/typography';
import { ButtonStyles } from '@stories/Components/Buttons/GeneralButton/Button.styles';
import styled from 'styled-components';
export const Container = styled.a `
  overflow: hidden;
  text-decoration: none;
  display: block;

  &:focus {
    outline: none;
  }

  &.focus-ring {
    outline: auto;
    outline-offset: 3px;
    outline-color: ${brand.black};
  }
`;
const Inner = styled.div `  

  @media ${until(Device.Desktop)} {
    position: relative;

    &:before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      display: block;
      background-color: var(--primaryPageThemeColorLight);
      border-radius: ${fluid(25, 50)};
      height: calc(100% - 112px);
    }
  }

  @media ${from(Device.Desktop)} {
    display: flex;
    flex-direction: row;
    height: 100%;
  }
  
`;
const MediaHolder = styled.div `
  --imageRatio: 300 / 225;
  --svgSize: 60px;

  display: flex;
  place-items: center;
  place-content: center;
  position: relative;
  overflow: hidden;
  border-radius: ${fluid(25, 50)};
  aspect-ratio: var(--imageRatio);
  background-color: var(--primaryPageThemeColor);
  margin: 0 20px;
  

  @media ${from(Device.TabletSmall)} {
    --imageRatio: 862 / 647;
    --svgSize: 88px;
  }

  @media ${from(Device.Desktop)} {
    flex: 0 0 48%;
    border-radius: 0 ${fluid(25, 50)} ${fluid(25, 50)} 0;
    padding: 0;
    margin: 0;
  }

  svg {
    width: var(--svgSize);
    ${transition('transform')}

    ${Container}:hover & {
      transform: scale(1.05);
    }
  }

  ${Container}[data-square='true'] & {
    --imageRatio: 1 / 1;

    @media ${from(Device.TabletSmall)} {
      --imageRatio: 1 / 1;
    }
  }
`;
const Image = styled.img `
  aspect-ratio: var(--imageRatio);
  object-fit: cover;
  ${transition('transform')}
  width: 100%;
  height: 100%;

  ${Container}:hover & {
    transform: scale(1.05);
  }
`;
const ContentArea = styled.div `
  position: relative;
  flex: 1;
  border-radius: ${fluid(25, 50)};

  @media ${from(Device.Desktop)} {
    flex: 1 0 50%;
    border-radius: ${fluid(25, 50)} 0 0 ${fluid(25, 50)};
    background-color: var(--primaryPageThemeColorLight);
    
  }
`;
const ContentInner = styled.div `
  display: block;
  padding: ${fluid(13, 72)} ${fluid(20, 80)} ${fluid(40, 80)};
  color: ${brand.grey.grey11};

`;
const ContentTop = styled.div `
  display: flex;
  align-items: center;
  gap: 24px;
  margin-bottom: 24px;

  @media ${until(Device.Desktop)} {
    justify-content: space-between;
  }
`;
const Author = styled.span `
  ${fonts.montserrat.regular};
  font-size: 16px;
  line-height: 24px;
  transform: translateY(-10px);
  margin-bottom: 10px;

  @media ${from(Device.Desktop)} {
    transform: translateY(-18px);
  }
`;
const Date = styled.time `
  ${fonts.montserrat.regular};
  font-size: 16px;
  line-height: 32px;
`;
const ReadTime = styled.div `  
  display: flex;
  align-items: center;
  gap: 8px;
  transform: translateY(8px);

  svg {
    width: 16px;
    height: 20px;
    margin-bottom: 5px;
  }

  span {
    ${fonts.montserrat.regular};
    font-size: 16px;
    line-height: 32px;
  }
`;
const Caption = styled.span `
  ${fonts.montserrat.regular};
  display: block;
  place-items: center;
  font-size: ${fluid(14, 16)};
  line-height: 30px;  
  padding: 5px ${fluid(20, 24)};
  background-color: var(--primaryPageThemeColor);
  border-radius: 100000px;
  color: ${brand.black};
`;
const Title = styled.h3 `
  ${headingStyles};
  ${fonts.lustria.regular};
  font-size: ${fluid(25, 50)};
  line-height: ${fluid(35, 67)};  
  margin-bottom: 24px;
`;
const Intro = styled.p `
  ${paragraphStyles};

  font-size: ${fluid(18, 20)};
  line-height: ${fluid(28, 30)};
  margin-bottom: ${fluid(21, 29)};;
`;
const ContentBottom = styled.div `
  display: flex;
  align-items: center;
  gap: ${fluid(32, 48)};
`;
const FakeButton = styled.div `
  margin-top: auto;
  pointer-events: none;

  ${Container}:hover & {
    ${ButtonStyles.ButtonInner} {
      --textAltColour: ${brand.grey.grey16};
      --hoverColour: var(--primaryPageThemeColor);

      &::after {
        background-color: var(--hoverColour);
      }
    }

    ${ButtonStyles.Text} {
      transform: translateY(-2px);
    }
  }
`;
export const FeaturedBlogCardStyles = {
    Author,
    Caption,
    Container,
    ContentArea,
    ContentBottom,
    ContentInner,
    ContentTop,
    Date,
    FakeButton,
    Image,
    Inner,
    Intro,
    MediaHolder,
    ReadTime,
    Title,
};
